export default __webpack_public_path__ + "static/media/self-employed.febf0b77.svg";